import "core-js/modules/es.error.cause.js";
export var notInitialized = function notInitialized() {
  throw new Error('uSES not initialized!');
};